export const COMMON = {
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 50,
    PHONE_NUMBER_MIN_LENGTH: 6,
    PHONE_NUMBER_MAX_LENGTH: 17,
    EMAIL_MAX_LENGTH: 100,
    JOB_MAX_LENGTH: 100,
    COMPANY_NAME_MAX_LENGTH: 100,
    ADDRESS_MAX_LENGTH: 100,
    BUSINESS_REG_NO_MAX_LENGTH: 30,
    NAME_PATTERN: '^[a-zA-Z ]*$',
    EMAIL_PATTERN: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
}